import { formatUnit, type DigitInfo } from '@myre/common-core';
import { type LangLocale } from '@myre/common-i18n';

import { DecimalPipe } from '@angular/common';
import { inject, Pipe, type PipeTransform } from '@angular/core';

import { LANGLOCALE } from '../../providers/langlocale';

@Pipe({
  name: 'myreNumber',
  pure: true,
})
export class NumberFormatPipe implements PipeTransform {
  private _numberPipe = inject(DecimalPipe);
  private readonly _langLocale = inject<LangLocale>(LANGLOCALE);

  public transform(
    value: number,
    factor: 1 | 1e3 | 1e6 = 1,
    digitsInfo: DigitInfo = '1.0-2',
    factoredDigitsInfo: DigitInfo = '1.2-2',
    forceFactor: boolean = false,
  ): string {
    switch (factor) {
      case 1e6: {
        return this._transformWithFactor(
          value,
          digitsInfo,
          factoredDigitsInfo,
          1e6,
          'M',
          forceFactor,
        );
      }
      case 1e3: {
        return this._transformWithFactor(
          value,
          digitsInfo,
          factoredDigitsInfo,
          1e3,
          'k',
          forceFactor,
        );
      }
      default: {
        return this._numberPipe.transform(value, digitsInfo, this._langLocale);
      }
    }
  }

  private _transformWithFactor(
    value: number,
    digitsInfo: DigitInfo,
    factoredDigitsInfo: DigitInfo,
    limit: number,
    unit: string,
    forceFactor: boolean = false,
  ): string {
    value = +value;

    if (Math.abs(value) >= limit || (forceFactor && value !== 0)) {
      return formatUnit(unit, factoredDigitsInfo)(
        value / limit,
        this._langLocale,
      );
    }

    return this._numberPipe.transform(value, digitsInfo, this._langLocale);
  }
}
